import { sendMessageToIframe, MSG_NAME_TO_IFRAME } from './handleIframeMessage/handleIframeMessage';

export const toggleHighlight = (highlight, elementPath) => {
  if (typeof elementPath !== 'string') return null;

  if (highlight) {
    const el = document.querySelector(elementPath);
    if (!el) return sendMessageToIframe({ name: MSG_NAME_TO_IFRAME.QaAssistantHighlightNotFound });
    el.scrollIntoView({ behavior: 'smooth' });
    return el!.classList.add('abtasty-highlight-event');
  }
  const el = document.querySelector(elementPath);
  if (!el) return null;
  return el!.classList.remove('abtasty-highlight-event');
};
